import { HttpClient } from '@angular/common/http';
import { inject, Injectable, isDevMode } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { catchError, of } from 'rxjs';
import { availableLocales, defaultLocale } from '@wheere-front/shared-ui';

@Injectable({ providedIn: 'root' })
class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpClient);

  getTranslation(lang: string) {
    return this.http.get<Translation>(`/assets/i18n/${lang}.json`).pipe(
      catchError(error => {
        // See integrator's transloco-config for the rationale: returning the
        // HttpErrorResponse as a "translation" would make every lookup miss
        // and render raw keys. Empty object lets Transloco's missing-key
        // fallback take over.
        console.error('Error fetching i18n data:', error);
        return of({} as Translation);
      })
    );
  }
}

export const configTransloco = {
  config: {
    availableLangs: availableLocales,
    defaultLang: defaultLocale,
    reRenderOnLangChange: true,
    prodMode: !isDevMode(),
    failedRetries: 1,
    fallbackLang: defaultLocale,
    missingHandler: {
      useFallbackTranslation: true,
    },
    // Nested JSON (e.g. {"shell":{"nav":{"sites":"Sites"}}}) — walk at runtime.
    flatten: {
      aot: false,
    },
  },
  loader: TranslocoHttpLoader,
};
